import axios from "axios";
import settingsService from "@/_services//settings-service";
import store from "@/store";
import API from "./index";
export default {
  baseUrl() {
      return settingsService.get("baseUrl");
  },

    get(filter) {
        console.log(API.x)
        store.commit("isLoading");
        const url = this.baseUrl() + "Logs/Filter";
        // console.log('Filter:', filter)
        return axios.post(url, filter)
        .then((response) => {
          return response.data;
        })
        .catch(error => { 
            // console.log(error)
            error = [];
            return error;
        })
        .finally(() => {
            store.commit("notLoading");
        })
    },
    getDetail(id) {
        store.commit("isLoading");
        const url = this.baseUrl() + "Logs/" + id
        return axios.get(url, {})
        .then((response) => {
          return response.data;
        })
        .finally(() => {
            store.commit("notLoading");
        })
    },
    getLogLevel() {
        store.commit("isLoading");
        const url = this.baseUrl() + "Logs";
        return axios.get(url, {})
        .then((response) => {
            // console.log("LogLevel: ", response.data);
          return response.data;
        })
        .catch(error => { 
            // console.log(error)
            error = "Info"
            return error;
        })
        .finally(() => {
            store.commit("notLoading");
        })
    },
    getUsers() {
        store.commit("isLoading");
        const url = this.baseUrl() + "Logs/GetApplications";
        return axios.get(url, {})
        .then((response) => {
            return response.data;
        })
        .catch(error => { 
            // console.log(error)
            error = [];
            return error;
        })
        .finally(() => {
            store.commit("notLoading");
        })
    },
    getLevels() {
        store.commit("isLoading");
        const url = this.baseUrl() + "Logs/GetLevels";
        return axios.get(url, {})
        .then((response) => {
          return response.data;
        })
        .catch(error => { 
            // console.log(error)
            error = [];
            return error;
        })
        .finally(() => {
            store.commit("notLoading");
        })
    },
    getLoggers() {
        store.commit("isLoading");
        const url = this.baseUrl() + "Logs/GetLoggers";
        return axios.get(url, {})
        .then((response) => {
          return response.data;
        })
        .catch(error => { 
            // console.log(error)
            error = [];
            return error;
        })
        .finally(() => {
            store.commit("notLoading");
        })
    },
    setLogLevel(level) {
        store.commit("isLoading");
        const url = this.baseUrl() + "Logs/SetLogLevel/" + level;
        return axios.post(url, {})
        .then((response) => {
          return response.data;
        })
        .finally(() => {
            store.commit("notLoading");
        })
    },
}